const Table = ELEMENT.Table;

if (!Table.render_override) {
  const render = Table.render;
  const created = Table.created;
  const doLayout = Table.methods.doLayout;
  Table.created = function () {
    //覆盖原有的updateElsHeight函数
    this.layout.updateElsHeight = tableLayoutUpdateElsHeight;
    created.call(this);
  };
  Table.methods.doLayout = function () {
    doLayout.call(this);
    this.$nextTick(() => {
      splitTableFooter.call(this);
      setFixelSize.call(this);
    });
  };
  Table.render = function (h) {
    let vnodes = render.call(this, h);
    if (vnodes.children) {
      //修复el-table存在汇总行和固定行头时el-table__fixed遮挡滚动条的问题
      let index = _.findIndex(vnodes.children, (vn) => {
        return vn?.data?.staticClass == "el-table__fixed";
      });
      let fixed = vnodes.children[index];
      if (fixed) {
        let footer = _.find(fixed.children || [], (it) => it?.data?.staticClass == "el-table__fixed-footer-wrapper");
        if (footer) {
          dsf.array.remove(fixed.children, footer);
          let footerVnode = h(
            "div",
            {
              ref: "fixedWrapperFooter",
              staticClass: "el-table__fixed_footer"
            },
            [footer]
          );
          vnodes.children.splice(index + 1, 0, footerVnode);
        } else {
          this.$nextTick(() => {
            setFixelSize.call(this);
          });
        }
        // this.$refs.
      }

      // let headerWrapper = _.find(vnodes.children, (vn) => {
      //   return vn?.data?.ref == "headerWrapper";
      // });
      // if (headerWrapper) {
      //   let fixedWrapper = _.find(vnodes.children, () => {
      //     return vn?.data?.ref == "fixedWrapper";
      //   });
      //   if (fixedWrapper) {
      //     let fixedHeaderWrapper = _.find(fixedWrapper.children, () => {
      //       return vn?.data?.ref == "fixedHeaderWrapper";
      //     });
      //     if (fixedHeaderWrapper?.data?.style) {
      //       _.each(fixedHeaderWrapper?.data?.style, (s) => {
      //         if (s.top) {
      //           // s.top=
      //         }
      //       });
      //     }
      //   }
      // }
    }
    return vnodes;
  };
  Table.render_override = true;
}
//重写table.layout中的更新元素高度函数,由于平台修正过el-table的边框样式，而其本身计算高度时为计算边框高度导致后续的高度会产生错误
function tableLayoutUpdateElsHeight() {
  if (!this.table.$ready) return Vue.nextTick(() => this.updateElsHeight());
  const { headerWrapper, appendWrapper, footerWrapper } = this.table.$refs;
  this.appendHeight = appendWrapper ? appendWrapper.offsetHeight : 0;

  if (this.showHeader && !headerWrapper) return;

  // fix issue (https://github.com/ElemeFE/element/pull/16956)
  const headerTrElm = headerWrapper ? headerWrapper.querySelector(".el-table__header tr") : null;
  const noneHeader = this.headerDisplayNone(headerTrElm);
  // const headerHeight = (this.headerHeight = !this.showHeader ? 0 : headerWrapper.offsetHeight);
  const headerHeight = (this.headerHeight = !this.showHeader ? 0 : headerWrapper.getBoundingClientRect().height);
  if (this.showHeader && !noneHeader && headerWrapper.offsetWidth > 0 && (this.table.columns || []).length > 0 && headerHeight < 2) {
    return Vue.nextTick(() => this.updateElsHeight());
  }
  const tableHeight = (this.tableHeight = this.table.$el.clientHeight);
  const footerHeight = (this.footerHeight = footerWrapper ? footerWrapper.offsetHeight : 0);
  if (this.height !== null) {
    this.bodyHeight = tableHeight - headerHeight - footerHeight + (footerWrapper ? 1 : 0);
  }
  this.fixedBodyHeight = this.scrollX ? this.bodyHeight - this.gutterWidth : this.bodyHeight;

  const noData = !(this.store.states.data && this.store.states.data.length);
  this.viewportHeight = this.scrollX ? tableHeight - (noData ? 0 : this.gutterWidth) : tableHeight;

  this.updateScrollY();
  this.notifyObservers("scrollable");
}

function splitTableFooter() {
  if (this.$refs.fixedWrapperFooter) {
    let fixedHeaderHeight = this?.$refs?.fixedHeaderWrapper?.offsetHeight || 0;
    let fixedBodyHeight = this?.$refs?.fixedBodyWrapper?.offsetHeight || 0;
    let fixed = this.$refs.fixedWrapper;
    if (fixed) {
      this.$refs.fixedWrapper.style.height = this.unitSize(fixedHeaderHeight + fixedBodyHeight + 2);
      this.$refs.fixedWrapperFooter.style.width = this.unitSize(this.$refs.fixedWrapper.offsetWidth);
      this.$refs.fixedWrapperFooter.style.height = this.unitSize(this.$refs.fixedFooterWrapper.offsetHeight);
    }
  }
}

function setFixelSize() {
  let scrollHeight = 0;
  let totalHeight = 0;
  if (this.layout && this.layout.scrollX) {
    scrollHeight = this.layout.gutterWidth;
    totalHeight = this.layout.tableHeight;
  }
  if (scrollHeight) {
    if (this.$refs?.fixedWrapper?.style?.height) {
      this.$refs.fixedWrapper.style.height = this.unitSize(totalHeight - scrollHeight);
    }
    if (this.$refs?.rightFixedWrapper?.style?.height) {
      this.$refs.rightFixedWrapper.style.height = this.unitSize(totalHeight - scrollHeight);
    }
  }
}
